import styled from 'styled-components';
import { Flex } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import BarStack from '../BarStack';

const Wrapper = styled(Flex)`
  align-items: center;
  gap: 8px;
  width: 52px;
  justify-content: space-between;
`;

const coverageRenderer = (value: number) => (
  <Wrapper>
    <Typography>{`${value}%`}</Typography>
    <BarStack value={value} />
  </Wrapper>
);

export default coverageRenderer;
